module.exports = __webpack_public_path__ + "static/media/icon_chat.2bd11823.svg";